// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__lNwfp","left":"InfoRow_left__2JPAv"};